import { render, staticRenderFns } from "./AddPersonIcon.vue?vue&type=template&id=c7e329ce&"
import script from "./AddPersonIcon.vue?vue&type=script&lang=js&"
export * from "./AddPersonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports